var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockOksvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_11343)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0ZM7.037 2.722H6.971C6.8729 2.72221 6.77849 2.75938 6.70658 2.8261C6.63467 2.89283 6.59055 2.98419 6.583 3.082L6.247 7.457C6.24007 7.5471 6.26472 7.63681 6.31673 7.71071C6.36873 7.78461 6.44485 7.83811 6.532 7.862L10.125 8.842C10.169 8.85419 10.2153 8.85603 10.2601 8.84737C10.305 8.83871 10.3472 8.8198 10.3835 8.7921C10.4198 8.7644 10.4492 8.72867 10.4694 8.68771C10.4897 8.64676 10.5001 8.60167 10.5 8.556V8.392C10.5001 8.32351 10.482 8.25622 10.4475 8.19702C10.4131 8.13781 10.3636 8.0888 10.304 8.055L7.778 6.611L7.424 3.072C7.41412 2.97616 7.36911 2.88737 7.29765 2.82275C7.2262 2.75812 7.13335 2.72223 7.037 2.722Z",
    fill: "#A7ADB7",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_11343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockOksvg);
export default __webpack_public_path__ + "static/media/clock-ok.svg.e4cab0f8b7b434016b11036215c41685.svg";
export { ForwardRef as ReactComponent };